import { TenantUserForm } from "components/Forms/TenantUserForm/TenantUserForm.tsx";
import { FC } from "react";
import { RoleEnum } from "types/enums.ts";

interface ManageAdvertiserFormProps {
    onSuccess?: () => void;
    onCanSubmitChange?: (canSubmit: boolean) => void;
    mode?: "create" | "detail";
    user?: App.Data.UserData;
}

export const ManageAdvertiserForm: FC<ManageAdvertiserFormProps> = ({ mode = "create", ...props }) => (
    <TenantUserForm {...props} mode={mode} role={RoleEnum.Advertiser} />
);
